var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ticket-kanban-board" }, [
    _vm.showScrollRightButton
      ? _c(
          "div",
          { staticClass: "scroll-right-task", on: { click: _vm.scrollRight } },
          [_vm._v("→")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showScrollLeftButton
      ? _c(
          "div",
          { staticClass: "scroll-left-task", on: { click: _vm.scrollLeft } },
          [_vm._v("←")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "drag-container" },
      _vm._l(_vm.groups, function (group, index) {
        return _c("TicketColumnCard", {
          key: group._id,
          attrs: {
            group: group,
            selectedTickets: _vm.selectedTickets,
            dndEnabled: index !== 0,
          },
          on: {
            "update-ticket-status": _vm.handleUpdateTicketStatus,
            "toggle-ticket-selection": _vm.handleToggleTicketSelection,
            "toggle-select-all": _vm.handleToggleSelectAll,
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }